import request from '@/utils/request'

// 获取 table 数据
export const getTableData = params =>
  request.post('/workflow-api/work-queue/page', params)

export const getAssign = username =>
  request.get(`/masterdata-api/user/active/query/${username}`)

export const saveAssign = params =>
  request.post('/workflow-api/work-queue/assign', params)
export const savePriority = params =>
  request.post('/workflow-api/work-queue/priority', params)

// 获取css详情
export const getCssDetail = params =>
  request.get(`/workflow-api/credit-css/approve/detail/${params.bpmId}`)
